import * as yup from 'yup'
import {ErrorForms} from '../../../../../libs/_fri/utils/enums'

export interface IProfile {
  name: string
  contactPhoneNumber: string
}

export const schemaProfile = yup.object().shape({
  name: yup.string().required(ErrorForms.GenericError),
  contactPhoneNumber: yup
    .string()
    .matches(/^[0-9]{8}$/, ErrorForms.InvalidPhone)
    .required(ErrorForms.GenericError),
})

export interface IUpdatePassword {
  cPassword: string
  password: string
  confirmPassword: string
}

export const passwordValidationSchema = yup.object().shape({
  cPassword: yup.string().required('La contraseña actual es requerida'),
  password: yup
    .string()
    .min(6, 'La contraseña debe tener al menos 6 caracteres')
    .matches(/[A-Z]/, 'La nueva contraseña debe tener al menos 1 mayúscula')
    .matches(/\d/, 'La nueva contraseña debe tener al menos 1 número')
    .matches(/[%&#,*!]/, 'La nueva contraseña debe tener al menos 1 carácter especial (%&#,*!)')
    .required('La nueva contraseña es requerida'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), undefined], 'Las contraseñas deben coincidir')
    .required('La confirmación de la nueva contraseña es requerida'),
})
